import React, { useCallback } from 'react';
import Icon from '@/components/Icon';
import Panel from '@/components/Panel';
import styles from './index.module.less';
import { useHistory } from 'react-router';

export interface ItemProps {
  title: string;
  fileName: string;
}

interface IPrpos {
  list: Array<ItemProps>;
  onTrack: (data: ItemProps, index: number) => void;
}

const QuestionList: React.FC<IPrpos> = ({ list = [], onTrack }) => {
  const history = useHistory();

  const onPressItem = useCallback(
    (id: string) => {
      history.push(`/details/${id}`);
    },
    [history],
  );

  return (
    <>
      {list &&
        list.length > 0 &&
        list.map((item, index) => {
          return (
            <Panel.Item
              key={index}
              text={item.title}
              right={<Icon iconName={'arrow_right'} imgClass={styles.arrow} />}
              onPress={() => {
                onPressItem(item.fileName);
                onTrack(item, index);
              }}
              hideLine={index === list.length - 1}
            />
          );
        })}
    </>
  );
};

export default QuestionList;
